import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/img/llq7.png'
import _imports_1 from '../../assets/img/llq8.png'


const _hoisted_1 = { class: "adviseB" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.centerDialogVisible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.centerDialogVisible) = $event)),
      title: "",
      width: "88%",
      "align-center": "",
      "close-on-click-modal": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.centerDialogVisible=false)),
          class: "footerSure"
        }, " 确定 ")
      ]),
      default: _withCtx(() => [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "diaBox" }, [
          _createElementVNode("p", { class: "title" }, "1.点击右上角的“三个点”按钮"),
          _createElementVNode("div", { class: "imgBox" }, [
            _createElementVNode("img", {
              class: "searchImg",
              src: _imports_0,
              alt: ""
            })
          ]),
          _createElementVNode("p", { class: "title title1" }, "2.选择在“浏览器中打开”"),
          _createElementVNode("div", { class: "imgBox" }, [
            _createElementVNode("img", {
              class: "searchImg",
              src: _imports_1,
              alt: ""
            })
          ])
        ], -1))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}